import { useState } from 'react'
import { colors, fontSize, size } from '@styles/theme'
import { useAuthContext } from '@contexts/authContext'
import { Link, useNavigate } from 'react-router-dom'
import useLoading from '@hooks/useLoading'
import useDialog from '@hooks/useDialog'
import styled from '@emotion/styled'
import { ActionButton, BackgroundImage, BottomButtonGroup, ButtonGroupClearFix, FlexSpacerDiv, FormContainer, FormLink, FormTitle, InputContainer, LinksContainer } from '@components/auth/landing/LandingElements'
import LandingPasswordResetModal from '@components/auth/landing/LandingPasswordResetModal'
import { EyeMaskEndAdornment } from '@elements/InputAdornments'
import { PositionedTopProgress } from '@elements/Loaders'
import ScreenContainer from '@screens/ScreenContainer'
import { Button, ButtonBase } from '@mui/material'
import { PiArrowRightBold } from 'react-icons/pi'
import { FormTextField, SheerFormTextField } from '@elements/Inputs'

const FormButtonLink = styled(ButtonBase)`
  text-align: center;
  flex-shrink: 0;
  color: ${colors.statusColors.chatting('light')};
  font-size: ${fontSize('md')}
`

const Login = () => {
  const [isPasswordResetOpen, openPasswordReset, closePasswordReset] = useDialog('landing_password_reset', 'landing-password-reset-open')
  const [loginState, setLoginState] = useState({ email: '', password: '' })
  const { isLoading, setIsLoading, isLoadingDelayed } = useLoading()
  const [isPasswordMasked, setIsPasswordMasked] = useState(true)
  const [isError, setIsError] = useState(false)
  const { login } = useAuthContext()
  const navigate = useNavigate()

  const handleChange = (e) => {
    setLoginState({ ...loginState, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    if (isLoading) return;
    e.preventDefault()
    setIsLoading(true)
    login(loginState)
      .then(() => {
        setIsLoading(false)
        setIsError(false)
        navigate('/map')
      })
      .catch(() => {
        setIsLoading(false)
        setIsError(true)
      })
  }

  return (
    <ScreenContainer style={{ minHeight: document.body.offsetHeight }}>
      <LandingPasswordResetModal
        isOpen={isPasswordResetOpen}
        setClosed={closePasswordReset}
      />
      <BackgroundImage src='https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-2-480w.jpeg' />
      <FormContainer onSubmit={handleSubmit}>
        <PositionedTopProgress isLoadingDelayed={isLoadingDelayed} />
        <FlexSpacerDiv />
        <InputContainer>
          <FormTitle>Log In</FormTitle>
          <SheerFormTextField
            className='do-not-hide-keyboard'
            name='email'
            value={loginState.email}
            type='email'
            label='Email'
            placeholder='Your email'
            onChange={handleChange}
            style={{ marginBottom: size(1) }}
          />
          <SheerFormTextField
            className='do-not-hide-keyboard'
            name='password'
            value={loginState.password}
            label='Password'
            type={isPasswordMasked ? 'password' : 'text'}
            placeholder='Your password'
            onChange={handleChange}
            error={isError}
            helperText={isError && 'Email or password not valid'}
            slotProps={{ input: {
              endAdornment: (
                <EyeMaskEndAdornment
                  isMasked={isPasswordMasked}
                  onClick={(e) => setIsPasswordMasked(!isPasswordMasked)}
                />
              ),
            }}}
          />
          <LinksContainer>
            <FormLink
              to='?modal-signup-age-verify=true&remove_background=true'>
              Sign Up Here
            </FormLink>
            &nbsp;
            or
            &nbsp;
            <FormButtonLink onClick={() => openPasswordReset()}>
              <u>Reset Password</u>
            </FormButtonLink>
          </LinksContainer>
        </InputContainer>
        <FlexSpacerDiv />
        <ButtonGroupClearFix />
        <BottomButtonGroup>
          <ActionButton
            variant='contained'
            size='large'
            type='submit'>
            {isLoading
              ? 'Loading...'
              : <>Log In&nbsp;<PiArrowRightBold /></>
            }
          </ActionButton>
        </BottomButtonGroup>
      </FormContainer>
    </ScreenContainer>
  )
}

export default Login
